<template>
  <div class="headerItem" v-loading="loading" element-loading-text="切换中···">
    <div class="pivotal-content">
      <NavigationLift :show="$store.state.showNav" />
      <div class="content-nav" v-show="showNav"></div>
      <div class="main-content" id="main-content">
        <div class="alltop" v-if="!hiddenLeft && !hiddenHeaderTop" id="alltop">
          <!-- <div class="switchRole">
            <el-radio-group v-model="radio2" size="small">
              <el-radio-button v-for="(item,index) in userInfo" :key="item.Strorgancode" :label="item.Strorganname + '—角色' + (index+1)" @change.native="changeRole(index)"></el-radio-button>
            </el-radio-group>
          </div> -->
          <div class="flex aic">
            <!-- <img src="../assets/images/xcx.png" alt="" style="width: 28px; height: 28px; margin-left:10px" class="cp" @click="showXCX(1)" />
            <div class="help cp" @click="showXCX(1)">员工服务</div>

            <img src="../assets/images/xcx.png" alt="" style="width: 28px; height: 28px; margin-left:10px" class="cp" @click="showXCX(2)" />
            <div class="help cp" @click="showXCX(2)">AI招聘</div>

            <img src="../assets/images/xcx.png" alt="" style="width: 28px; height: 28px; margin-left:10px" class="cp" @click="showXCX(3)" />
            <div class="help cp" @click="showXCX(3)">小杰之家</div>

            <i class="el-icon-chat-dot-square cp" style="font-size: 28px; margin-left: 10px; color: #19bd92" v-if="roletype && roletype.indexOf('adm') > -1" @click="jumpChat"></i>
            <div class="help cp" @click="jumpChat" v-if="roletype && roletype.indexOf('adm') > -1">
              小杰（AI服务官）
            </div>

            <img src="../assets/images/qw.png" alt="" style="width: 36px; height: 38px; margin-left: 5px" class="cp" @click="showQWqrcode()" />
            <div class="help cp" @click="showQWqrcode()" style="margin-right:15px">在线帮助</div> -->
            <!-- <el-tooltip class="item" effect="dark" content="在线帮助" placement="left"> -->

            <!-- </el-tooltip> -->

            <el-popover placement="bottom-end" width="311" trigger="manual" v-model="downVisible">
              <div class="flex sb" style="width:100%">
                <div style="font-size: 16px;">导出/下载记录</div>
                <div style="margin-bottom: 10px;">
                  <i class="el-icon-close cp" style="font-size: 20px;" @click="closePopover"></i>
                </div>
              </div>
              <el-table :data="gridData" v-loading="downLoading" max-height="350">
                <el-table-column width="150" :show-overflow-tooltip="true" property="fileName" label="文件名"></el-table-column>
                <el-table-column width="80" property="status" label="状态">
                  <template slot-scope="{row}">{{ row.status == 0 ? '生成中' : row.status == 1 ? '已完成' : row.status == -1 ? '失败' : ''}}</template>
                </el-table-column>
                <el-table-column width="80" :show-overflow-tooltip="true" property="name" label="操作">
                  <template slot-scope="{row}">
                    <div class="injuryTabBtn">
                      <el-button v-if="row.status == 1" type="text" size="small" @click="down(row)">下载</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="flex aic" slot="reference" @click="showDownList()">
                <img src="../assets/images/download.png" alt="" style="width: 24px; height: 22px; margin-left: 5px" class="cp" />
                <div class="help cp" style="margin-right:15px">导出/下载记录</div>
              </div>
            </el-popover>
            <i class="el-icon-chat-dot-square cp" style="font-size: 28px; margin-left: 10px; color: #19bd92" v-if="roletype && roletype.indexOf('adm') > -1" @click="jumpChat"></i>
            <div class="help cp" @click="jumpChat" v-if="roletype && roletype.indexOf('adm') > -1">
              小杰（AI服务官）
            </div>
            <div class="user aic">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link cp">
                  <el-avatar size="small">user</el-avatar>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="showuser()" v-if="roletype && roletype.indexOf('adm') > -1">切换身份</el-dropdown-item>
                  <el-dropdown-item @click.native="toMyInfo()">修改密码</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span class="username">{{ userName }}</span>
              <el-popconfirm confirm-button-text="退出登录" cancel-button-text="不了" @confirm="signOut" icon="el-icon-info" icon-color="red" title="确定退出登录吗？">
                <i class="el-icon-switch-button cp" slot="reference" title="退出登录">
                </i>
              </el-popconfirm>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </div>

      <el-dialog title="切换身份" :visible.sync="visible" width="384px">
        <el-select @change="selectChange" filterable v-model="strtopuserid" clearable placeholder="请选择需要切换登录的用户" style="width: 90%">
          <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="visible = false">取消</button>
          <button class="search" @click="changeuser" style="margin-left: 10px; font-weight: 600">
            确定
          </button>
        </span>
      </el-dialog>

      <!-- <div class="helpDialog">
        <el-dialog title="在线帮助" :visible.sync="visibleHelp" width="500px">

          <div class="helpItem flex">
            <div class="helpTitle">提示：</div>
            <div>请确认您本地已下载企业微信，如未下载可点击 <span class="keynote">二维码联系</span>，手机扫码即可联系相关人员</div>
          </div>

          <div class="helpItem flex">
            <div class="helpTitle">本地企微联系：</div>
            <div class="txtBtn cp" @click="help">点击打开</div>
          </div>
          <div class="helpItem flex">
            <div class="helpTitle">扫码联系：</div>
            <div class="txtBtn cp" @click="visibleQWqrcode = true">二维码联系</div>
          </div>

          <el-dialog width="400px" title="" :visible.sync="visibleQWqrcode" append-to-body custom-class="helpDialog">
            <div class="qrcodeBox">
              <div class="qrcodeTips">企业微信扫一扫</div>
              <img src="../assets/images/helpQRcode.png" alt="" style="width:300px;height: 300px;">
            </div>
          </el-dialog>
        </el-dialog>
      </div> -->

      <el-dialog width="400px" title="" :visible.sync="visibleQWqrcode" custom-class="helpDialog">
        <div class="qrcodeBox">
          <div class="qrcodeTips">企业微信扫一扫</div>
          <img src="../assets/images/helpQRcode.png" alt="" style="width: 300px; height: 300px" />
        </div>
      </el-dialog>

      <el-dialog width="400px" title="" :visible.sync="visibleXCX" custom-class="helpDialog">
        <div class="qrcodeBox">
          <div class="qrcodeTips">微信扫一扫</div>
          <img :src="xcxUrl" alt="" style="width: 300px; height: 300px" />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import ygfw from '../assets/images/ygfw.jpg';
  import aizp from '../assets/images/aizp.jpg';
  import xjzj from '../assets/images/xjzj.jpg';
  import NavigationLift from "../components/navigationLift.vue";
  import xz from "../common";
  import baseLayout from "../base.vue";
  export default {
    name: "headerItem",
    components: {
      NavigationLift,
    },
    data() {
      return {
        loading: false,
        showNav: true,
        showChildrenNav: false,
        showChildrenNav2: false,
        showChildrenNav3: false,
        visibleQWqrcode: false, //企微二维码弹窗
        visibleHelp: false, //帮助弹窗
        showChildren: false,
        roletype: "",
        hiddenLeft: this.$store.state.hiddenLeft,
        active: "apply-manage",
        hasApply: false,
        hasCompany: false,
        hasDelivery: false,
        hasInterview: false,
        purviewShow: false,
        jobstartShow: false,
        // 企业审核账号
        companyValidate: false,
        visible: false,
        radio2: "",
        visible: false,
        userName: "",
        userInfo: [],
        userid: "",
        strtopuserid: "",
        userList: [],
        isChatWebTop: true,
        labelLoginArr: [],
        hiddenHeaderTop: this.$store.state.hiddenHeaderTop,
        dtlQuery: {
          mainuserid: "",
          useridr: "",
        },
        //切换成功需存的参数
        transQuery: {
          userName: "",
          ganName: "",
          loginRoletype: "",
          gancode: "",
          lastID: "",
          UserNumber: "",
        },
        visibleXCX: false,
        xcxUrl: '',
        gridData: [{
          fileName: "已开票列表导出.xlsx",
          fileUrl: "excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
          status: 1
        },{
          fileName: "已开票列表导出.xlsx",
          fileUrl: "excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
          status: 1
        },{
          fileName: "已开票列表导出.xlsx",
          fileUrl: "excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
          status: 1
        },{
          fileName: "已开票列表导出.xlsx",
          fileUrl: "excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
          status: 1
        },{
          fileName: "已开票列表导出.xlsx",
          fileUrl: "excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
          status: 1
        },{
          fileName: "已开票列表导出.xlsx",
          fileUrl: "excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
          status: 1
        },{
          fileName: "已开票列表导出.xlsx",
          fileUrl: "excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
          status: 1
        },{
          fileName: "已开票列表导出.xlsx",
          fileUrl: "excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
          status: 1
        }],
        downVisible: false,
        downLoading: false,
        _pollTimer: null
      };
    },
    created() {
      this.userid = Cookies.get("userid-b");
      this.getDetail(false);
    },
    watch: {
      $route: {
        handler: function () {
          // 判断杰博
          if (
            Cookies.get("userid-b") === "a8034cc9-ea31-4df2-91f6-33b375253d4d"
          ) {
            this.jobstartShow = true;
          }
        },
        immediate: true,
      },
      "$store.state.hiddenLeft": function () {
        this.hiddenLeft = this.$store.state.hiddenLeft;
      },
      "$store.state.hiddenHeaderTop": function () {
        this.hiddenHeaderTop = this.$store.state.hiddenHeaderTop;
      },
      '$store.state.menu.refreshList'(newVal) {
        if (newVal) {
          this.showDownList()
          this.$store.commit('SET_REFRESH_LIST', false)
        }
      },
    },
    computed: {
      projectListNum() {
        //返回项目总数
        return this.$store.state.JOBS.checkJobsNum;
      },
      purviews() {
        return this.$store.state.purview;
      },
      // userName() {
      //   return this.$store.state.adminName;
      // },
    },
    methods: {
      showHelp() {
        this.visibleHelp = true;
      },
      // 跳转杰博数字人
      jumpChat() {
        let routerUrl = this.$router.resolve({
          path: "/chatWeb",
        });
        window.open(routerUrl.href, "_blank");
      },
      help() {
        xz.getqwUserid().then((res) => {
          if (res.status == "ok") {
            if (res.totalcount > 0) {
              let qwuserid = res.msg;
              if (qwuserid) {
                let data = {
                  interface: {
                    interfaceName: "Getlaunch_code",
                      para: {
                        operatoruserid: qwuserid,
                      },
                  },
                };
                xz.Getlaunch_code(data).then((res) => {
                  if (res.status == "ok") {
                    window.location.href =
                      "wxwork://launch?launch_code=" + res.launch_code;
                  }
                  console.log(res);
                });
              } else {
                this.$message.warning("打开企微失败，请扫码联系");
              }
            } else {
              this.$message.warning("打开企微失败，请扫码联系");
            }
          } else {
            this.$message.warning("打开企微失败，请扫码联系");
          }
        });
        // setTimeout(()=>{
        //   window.location.href = 'wxwork://launch?launch_code=KiUfOGf_MxkKBkqM06nDj0H7zzZzv5y2yT9_MSxBgexrDhVYSdAyjNF8944hh8Ae';
        // },100)
      },
      showQWqrcode() {
        this.visibleQWqrcode = true;
      },
      key() {
        return this.$route.path;
      },
      toMyInfo() {
        this.$router.push({
          path: "/employee-editMyPassword",
        });
      },
      getDetail(type) {
        let that = this;
        if (this.isNull(this.strtopuserid)) {
          that.dtlQuery.useridr = Cookies.get("userid-b");
        } else {
          that.dtlQuery.useridr = this.strtopuserid;
        }
        xz.getauthJbUserDetailNew(that.dtlQuery.useridr, that.dtlQuery).then((res) => {
          // console.log('sss',res)
          if (res.status == "ok") {
            window.localStorage.setItem("roleName", res.msg.StationName);
            window.localStorage.setItem("userName", res.msg.Username);
            window.localStorage.setItem("strmobile", res.msg.Strmobile);
            this.userInfo = res.msg;
            this.labelLoginArr = res.msglabel;
            that.transQuery.userName = res.msg.Username;
            that.transQuery.ganName = res.msg.Strorganname;
            that.transQuery.UserNumber = res.msg.UserNumber;
            if (type) {
              that.transQuery.loginRoletype = res.msg.Strstation;
              that.transQuery.gancode = res.msg.Strorgancode;
              that.transQuery.lastID = Cookies.get("userid-b");
              this.getleft(
                that.strtopuserid,
                that.strtopuserid
              );
            } else if (!type) {
              this.roletype = res.msg.Strstation; //默认进来
              this.userName = res.msg.Username + "-" + res.msg.UserNumber;
              let psw = localStorage.psw0;
              let idcode = res.msg.Stridcard.substring(
                res.msg.Stridcard.length - 6
              );
              if (psw && psw === idcode + "##") {
                window.localStorage.setItem("needEdit", "true");
                this.$router.push({
                  path: "/employee-editMyPassword",
                });
              } else {
                window.localStorage.setItem("needEdit", "false");
              }
            }
            // console.log('l', role, this.radio2, localStorage.needEdit)
          } else {
            this.userInfo = [];
          }
        });
      },
      getleft(id, id1) {
        let that = this;
        xz.bgetLoginauthPowerInfChange(id, id1)
          .then((res2) => {
            let resRouter = res2;
            // console.log(111111111, resRouter);
            if (res2.status == "ok") {
              this.roletype = that.transQuery.loginRoletype; //切换账号时重新赋值
              Cookies.set("userid-b", this.strtopuserid);
              Cookies.set("entid-b", this.strtopuserid);
              if (!this.isNull(that.labelLoginArr)) {
                window.localStorage.setItem('tableids', JSON.stringify(that.labelLoginArr))
              }
              this.userName =
                that.transQuery.userName + "-" + that.transQuery.UserNumber;
              window.localStorage.setItem("userName", that.transQuery.userName);
              window.localStorage.setItem("ganName", that.transQuery.ganName);
              window.localStorage.setItem(
                "loginRoletype",
                that.transQuery.loginRoletype
              );
              window.localStorage.setItem("gancode", that.transQuery.gancode);
              localStorage.setItem("lastID", that.transQuery.lastID);
              // window.localStorage.setItem(
              //   "activeRoutes",
              //   JSON.stringify(resRouter.msg.parent)
              // );
              let activeRouter = resRouter.msg.parent;
              Cookies.set("token1", resRouter.msg.token);
              let arrayRouter = [];
              that.generaMenu(arrayRouter, activeRouter);
              localStorage.setItem("defaultIndex", 0);
              // 存储到本地中，不然刷新无法获取路由 这个要加上路由守卫
              localStorage.setItem("router", JSON.stringify(activeRouter));
              that.$store.dispatch("SetRouter", activeRouter);
              activeRouter = arrayRouter;
              // console.log("动态路由",activeRouter);
              // console.log(this.$router);
              localStorage.setItem("activeRouter", JSON.stringify(activeRouter));
              that.$router.addRoutes(activeRouter);
              that.$router.push({
                path: activeRouter[0].path,
              });
              that.loading = false;
              // 存入vuex
              setTimeout(() => {
                location.reload();
              }, 100);
              // console.log("全部路由",this.$router.options.routes[0].path);
            } else {
              this.$message({
                message: res2.msg,
                type: "error",
              });
              that.loading = false;
              return;
            }
          })
          .catch((err) => {
            console.log("登录错误", err);
          });
      },
      //去重
      reductionFn(arr) {
        let res = new Map();
        return arr.filter(
          (item) =>
          !res.has(item.powercode) && res.set(item.powercode, item.powercode)
        );
      },
      generaMenu(routes, data) {
        // console.log('generaMenu', data)
        let menu;
        data.forEach((item) => {
          // console.log('sss', item)
          menu = {
            path: item.path === "#" ? item.path + "_key" : item.path,
            component: item.children && item.children.length > 0 ?
              baseLayout : (resolve) =>
              require([`@/views/${item.powerEnName}${item.path}`], resolve),
            // hidden: true,
            // redirect: 'noRedirect',
            // alwaysShow: false,
            checked: false,
            activeMenu: item.activeMenu,
            name: item.name,
            powerEnName: item.powerEnName,
            powercode: item.powercode,
            powername: item.powername,
            meta: {
              title: item.meta.title,
              checked: false,
              icon: item.meta.icon,
              //   noCache: true,
              //   breadcrumb: true,
              //   affix: false
            },
            children: [],
          };
          if (item.children && item.children.length > 0) {
            this.generaMenu(menu.children, item.children);
          }
          routes.push(menu);
        });
      },
      signOut() {
        Cookies.remove("userid-b");
        Cookies.remove("entid-b");
        Cookies.remove("token");
        this.$store.commit("setLogin", false);
        localStorage.removeItem("router");
        localStorage.removeItem('activeRoutes');
        localStorage.removeItem("activeRouter");
        localStorage.removeItem("isPartner");
        location.href = "/";
      },
      selectChange() {
        this.$forceUpdate();
      },
      //切换身份
      showuser() {
        let dataPage = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        };
        xz.getauthUserInfoByorgancode(dataPage).then((res) => {
          if (res && res.totalcount > 0) {
            this.userList = res.msg;
          } else {
            this.userList = [];
          }
        });
        this.visible = true;
      },
      changeuser() {
        if (this.strtopuserid && this.strtopuserid != undefined) {
          this.loading = true;
          this.visible = false;
          this.getDetail(true);
        } else {
          this.$message.warning("请选择需要切换登录的用户");
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0
        );
      },
      showXCX(type) {
        this.xcxUrl = type == 1 ? ygfw : type == 2 ? aizp : xjzj;
        this.visibleXCX = true;
      },
      showDownList() {
        this.downVisible = true;
        this.getDownList();
      },
      getDownList() {
        // 清除旧定时器，防止重复轮询导致内存泄漏
        if (this._pollTimer) {
          clearTimeout(this._pollTimer);
          this._pollTimer = null;
        }
        this.downLoading = true;
        const userId = Cookies.get("userid-b");
        // 对参数进行编码，防止特殊字符破坏 URL 结构
        const str = `GetDownLoadFileData?UserId=${encodeURIComponent(userId)}&Size=10`;
        xz.BasicGetFun(str).then(res => {
          if (res.status === "ok") {
            this.gridData = res.data;
            this.downLoading = false;
            // 检查是否需要轮询，增加数组类型检查以防报错
            const hasPending = Array.isArray(res.data) && res.data.some(item => item.status === 0);
            if (hasPending && this.downVisible) {
              this._pollTimer = setTimeout(() => {
                this.getDownList();
              }, 5000);
            }
          } else {
            this.gridData = [];
            this.downLoading = false;
          }
        }).catch(() => {
          // 异常处理，确保 loading 状态重置
          this.downLoading = false;
          // 出错时清除定时器，停止轮询
          if (this._pollTimer) {
            clearTimeout(this._pollTimer);
            this._pollTimer = null;
          }
        });
      },
      closePopover() {
        this.downVisible = false;
      },
      down(row) {
        var path = 'https://emp.joball.net/' + row.fileUrl;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.setAttribute('download', row.fileName);
        aTag.click();
      },
    },
  };
</script>

<style scoped>
  .h_chat {
    color: #19bd92;
    text-decoration: underline;
    margin-right: 15px;
    font-size: 14px;
  }

  .nav-show {
    transform: rotateZ(-90deg) !important;
  }

  .nav-list-angle {
    margin-left: 30px;
    font-size: 20px;
    transition: all 0.2s linear;
    transform: rotateZ(90deg);
  }

  .activeFoucs {
    background: #5f4b8b;
  }

  .activeFoucs .nav-link {
    background: #5f4b8b !important;
    border-left: none !important;
  }

  .haveNum .nav-icon,
  .activeFoucs .nav-icon {
    color: #fff;
  }

  .activeFoucs .nav-link span {
    color: #fff;
  }

  .itemScatter {
    background: #5f4b8b;
  }

  .itemScatter span {
    color: #fff;
  }

  .itemScatter a {
    background: #5f4b8b !important;
  }

  .itemScatter a span {
    color: #fff !important;
  }

  .haveNum {
    background: #fa7268;
  }

  .haveNum .nav-link span {
    color: #fff;
  }

  .alltop {
    height: 36px;
    background: #fff;
    display: flex;
    justify-content: flex-end;
    padding: 5px 12px;
    margin: 0 0 5px;
    /* border-bottom: 1px solid #f2f2f2; */
  }

  /* .switchRole {
  line-height: 36px;
} */
  .user {
    height: 36px;
    /* line-height: 36px; */
  }

  .user i {
    font-size: 28px;
    margin-left: 10px;
    color: #333;
  }

  .user .el-dropdown {
    height: 28px !important;
  }

  .username {
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    margin-left: 5px;
  }

  .helpTitle {
    font-weight: bold;
    color: #999;
    white-space: nowrap;
  }

  .txtBtn {
    color: #19bd92;
  }

  .helpItem {
    margin-bottom: 10px;
  }

  .help {
    font-size: 14px;
    color: #555555;
    margin: 0 5px;
  }

  .keynote {
    padding: 2px 4px;
    /* font-size: 90%; */
    color: #c7254e;
    background-color: #f9f2f4;
    border-radius: 4px;
  }

  .qrcodeTips {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .qrcodeBox {
    text-align: center;
  }
</style>

<style>
  .el-badge__content {
    position: relative;
    /* left: 5px; */
    bottom: 4px;
  }

  .el-popconfirm__action {
    margin-top: 10px !important;
  }

  .helpDialog .el-dialog__body {
    padding-top: 10px;
  }
</style>